var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"comment"}},[(_vm.commentVisible)?_c('v-card',{staticClass:"comment",staticStyle:{"max-width":"30vw"},attrs:{"tonal":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("comment.comment")))]),_c('v-card-text',[_vm._v(_vm._s(_vm.comment || _vm.$t("comment.noComment")))])],1):_vm._e(),_vm._v("> ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }